import $ from 'jquery';
import mod_analyse from "@/store/mods/clinique/analyses.js"
import mod_examen from "@/store/mods/clinique/examens.js"

export default {
    name: 'all-types-examen-analyse',
    components: {},
    props: ["passed"],
    data() {
        return {
            analyse_checked: [],
            examen_checked: [],
            typeChoice: "",
            display_error: false,
            list_analyses_by_categorie: [],
            list_examens: [],
            list_type_consultations: [],
        }
    },

    computed: {
        analyses_selected() {
            return this.$store.getters["analyses_selected"];
        },

        examens_selected() {
            return this.$store.getters["examens_selected"];
        }
    },

    mounted() {
        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);

        setTimeout(() => {
            $('.shw2').fadeIn()
        }, 700);

        this.analyse_checked = this.analyses_selected;      // Set Checked Analyses
        this.examen_checked = this.examens_selected;
        this.selectAnalysesByCategorie()
        this.selectListExamens()
        this.setInitValues()
    },

    methods: {
        selectAnalysesByCategorie() {
            mod_analyse.getCategoriesAnalyse().then((analyses) => {
                this.list_analyses_by_categorie = analyses
            })
        },

        selectListExamens() {
            mod_examen.getExamens().then((examens) => {
                this.list_examens = examens
            })
        },

        setInitValues() {
            this.typeChoice = this.passed;
        },

        getOrderExam() {
            if (this.typeChoice == "exam") return "order-1"
            else return "order-2"
        },

        getOrderAna() {
            if (this.typeChoice == "ana") return "order-1"
            else return "order-2"
        },

        validerChoix() {

            if (this.analyse_checked.length == 0 && this.examen_checked.length == 0) {
                this.display_error = true;
            } else {

                if (this.typeChoice == "ana") {
                    this.$store.commit("SET_ANALYSES_SELECTED", this.analyse_checked);
                    this.$store.commit("SET_EXAMENS_SELECTED", []);
                } else if (this.typeChoice == "exam") {
                    this.$store.commit("SET_EXAMENS_SELECTED", this.examen_checked);
                    this.$store.commit("SET_ANALYSES_SELECTED", []);
                }
                //this.$store.commit("SET_EXAMENS_SELECTED", this.examen_checked);
                this.analyse_checked = [];
                this.examen_checked = [];
                this.$store.commit("SET_TYPE_ACTION_SELECTED", "bon_medical")

                this.$router.push({ name: 'choice-patient' })
            }
        },

        clickOnAnalyse() {
            this.doWarningMsg('Le prix de cette analyse n\'a pas été défini')
        },

        clickOnExamen() {
            this.doWarningMsg('Le prix de cet examen n\'a pas été défini')
        },

        doWarningMsg: function(msg) {
            if (this.$toasted != null) this.$toasted.clear()
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 2000,
                theme: 'toasted-warning',
                type: 'warning'
            })
        },

    }
}